import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import MainContainer from '../../../components/MainContainer';
import BookingItemListPage from './BookingItemList';
import BookingItemModalPage from './BookingItemModal';
import BookingCategorySearchModal from './BookingCategorySearchModal';
import BookingSubCategorySearchModal from './BookingSubCategorySearchModal';
import './BookingItem.css';

@inject(
    'loginStore',
    'BookingItemStore'
)
@observer
class BookingItemPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
    }

    // ON CANCEL

    bookingItemModalOnCancel = () => {
        this.props.BookingItemStore.setShowBookingItemModal(false);
    }

    bookingCategorySearchModalOnCancel = () => {
        this.props.BookingItemStore.setShowBookingCategorySearchModal(false);
    }

    bookingSubCategorySearchModalOnCancel = () => {
        this.props.BookingItemStore.setShowBookingSubCategorySearchModal(false);
    }

    render() {
        const {
            showBookingItemModal,
            bookingItemTitle,
            showBookingCategorySearchModal,
            showBookingSubCategorySearchModal
        } = this.props.BookingItemStore;

        return (
            <MainContainer title='Booking Item' menukey='booking-item'>
                <Modal
                    title={bookingItemTitle}
                    visible={showBookingItemModal}
                    width={800}
                    footer={null}
                    onCancel={this.bookingItemModalOnCancel}
                    zIndex={1000}
                >
                    <BookingItemModalPage />
                </Modal>

                <Modal
                    title="Search Booking Category"
                    visible={showBookingCategorySearchModal}
                    width={800}
                    footer={null}
                    onCancel={this.bookingCategorySearchModalOnCancel}
                    zIndex={2000}
                >
                    <BookingCategorySearchModal />
                </Modal>

                <Modal
                    title="Search Booking Sub Category"
                    visible={showBookingSubCategorySearchModal}
                    width={800}
                    footer={null}
                    onCancel={this.bookingSubCategorySearchModalOnCancel}
                    zIndex={2000}
                >
                    <BookingSubCategorySearchModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <BookingItemListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default BookingItemPage;
